var AnalyticsNode =
/** @class */
function () {
  function AnalyticsNode() {}

  AnalyticsNode.load = function () {
    return Promise.reject(new Error('AnalyticsNode is not available in browsers.'));
  };

  return AnalyticsNode;
}();

export { AnalyticsNode };